import SearchBox from "../components/SearchBox";
import ResultsPageSubHeader from "../components/ResultsPageSubHeader";
import FilterDesktop from "../components/FilterDesktop";
import { Link } from "react-router-dom";
import { T } from "@tolgee/react";
import ResultsDisplay from "../components/ResultsDisplay";
import LoadingIndicator from "../components/LoadingIndicator";
import { useFilter } from "../hooks/useFilter";
import useAppState from "../store/appState";
import Overlay from "../components/Overlay";
import CompanySelection from "../components/CompanySelection";
import { useState } from "react";

function ResultsPage() {
  const { displayMobileFilterModal } = useAppState();
  const { materials, activeFilters, setActiveFilters, categories, isFetching, sortby, setSortby, companies, data, defaultCountry, vectorSearch, setVectorSearch } = useFilter();

  return (
    <div className="bg-white">
      {displayMobileFilterModal && <Overlay activeFilters={activeFilters} setActiveFilters={setActiveFilters} categories={categories} materials={materials} data={data} />}
      <ResultsPageSubHeader />

      <section className=" mx-4 lg:ml-[114px] lg:mr-[115px] mt-[19px] mb-[30px] lg:mb-[10px]  lg:mt-[46px] ">
        <p className="lg:hidden mb-[19px] text-grey-4 ">
          <Link className="text-grey-1-sp underline decoration-1 underline-offset-2 font-semibold" to="/" rel="noopener noreferrer">
            <T keyName="ResultsPage.breadcrumb.homepage-link" />
          </Link>
          &nbsp;/&nbsp;
          <T keyName="ResultsPage.breadcrumb.results" />
        </p>

        <div className="flex flex-col md:flex-row items-center justify-between gap-3 mb-[28px] lg:mb-[34px]">
          <SearchBox smartSearch={vectorSearch} />
          <div className="flex items-center justify-between gap-3">
            <div>
              <label id="smart-search-label" className="text-[16px] leading-5 font-semibold font-roboto">
                <T keyName="ResultsPage.SmartSearch" />
              </label>
            </div>

            <div className="group relative inline-flex w-11 shrink-0 rounded-full bg-gray-200 p-0.5 outline-offset-2 outline-[#ea2c14] ring-1 ring-inset ring-gray-900/5 transition-colors duration-200 ease-in-out has-[:checked]:bg-[#ea2c14] has-[:focus-visible]:outline has-[:focus-visible]:outline-2">
              <span className="size-5 rounded-full bg-white shadow-sm ring-1 ring-gray-900/5 transition-transform duration-200 ease-in-out group-has-[:checked]:translate-x-5" />
              <input
                id="smart-search"
                name="smart-search"
                type="checkbox"
                aria-labelledby="smart-search-label"
                aria-describedby="smart-search-description"
                className="absolute inset-0 size-full appearance-none focus:outline-none"
                onChange={(e) => setVectorSearch(e.target.checked)}
              />
            </div>
          </div>
          <div className="grow"></div>
          {companies && <CompanySelection companies={companies} />}
        </div>
        {!isFetching && materials && (
          <div className="grid gap-0 lg:gap-[102px] grid-cols-[0_1fr] lg:grid-cols-[304px_1fr] mb-[80px]">
            <div className="overflow-hidden ">
              <div className="hidden lg:block">
                <FilterDesktop activeFilters={activeFilters} setActiveFilters={setActiveFilters} categories={categories} materials={materials} allMaterials={data} />
              </div>
            </div>
            <div className="col-start-2">
              <ResultsDisplay materials={materials} activeFilters={activeFilters} sortby={sortby} setSortby={setSortby} defaultCountry={defaultCountry} />
            </div>
          </div>
        )}
      </section>

      <div className="flex flex-col  text-center font-inter leading-[28px] text-[18px] lg:leading-[24px] lg:text-[16px] font-semibold">
        {isFetching && (
          <div className="h-[25vh]">
            <LoadingIndicator />
          </div>
        )}

        {!isFetching && !materials && (
          <div className="h-[25vh]">
            <T keyName="ResultsPage.p.no-results-found" />
          </div>
        )}
      </div>
    </div>
  );
}

export default ResultsPage;
